// src/app/store.js
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import productReducer from './product/productSlice.ts'
import userReducer from './user/userSlice.ts';
import footerReducer from './footer/footerSlice.ts'
import cartReducer from './cart/cartSlice.ts';
import checkoutReducer from './cart/checkoutSlice.ts';
import ordersReducer from './dashboard/ordersSlice.ts'
import resellerReducer from './dashboard/resellersSlice.ts'
import orderDetailsReducer from "./dashboard/orderDetailsSlice.ts";
import cartMiddleware from "./middleware/updateProductsMiddleware.ts";
import LocalStorage, { ADDITIONAL_NOTES, DELIVERY_ADDRESS } from "../helpers/localStorage.ts";

const reducers = combineReducers({
    user: userReducer,
    cart: cartReducer,
    checkout: checkoutReducer,
    orders: ordersReducer,
    footer: footerReducer,
    reseller: resellerReducer,
    orderDetails: orderDetailsReducer,
    product: productReducer,
});

export const shopStore = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(cartMiddleware),
});

//for tests
export const setupStore = (preloadedState?: Partial<RootState>) =>
    configureStore({
        reducer: reducers,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(cartMiddleware),
        preloadedState
    });

shopStore.subscribe(() => {
    const state = shopStore.getState();
    const cache = new LocalStorage();

    cache.set(ADDITIONAL_NOTES, state.cart.additionalNotes);
    cache.set(DELIVERY_ADDRESS, state.checkout.shippingAddress.data as object);
});

export type AppStore = typeof shopStore;
export type RootState = ReturnType<typeof reducers>;
export type AppDispatch = typeof shopStore.dispatch;

export default shopStore;